import React, { useState } from 'react';
import { Row, Col, Input, Button, Alert, Container, UncontrolledTooltip } from "reactstrap";
import { Link, useNavigate } from 'react-router-dom';
import logo from "../../assets/images/logo.png";
import authBanner from "../../assets/images/Login_Picture.png";
import { postEmailOTP, postVerifyEmailOTP, resetPassword } from '../../helper/api-methods';
import OtpInput from 'react-otp-input';
import { showToast } from '../../components/Toast';

function ForgotPassword() {

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [passwordRepeat, setPasswordRepeat] = useState("");
    const [otp, setOtp] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showPasswordRepeat, setShowPasswordRepeat] = useState(false);
    const [currentTab, setCurrentTab] = useState(1);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({ username: "", password: "", apiError: "" });
    document.title = "Wiserep";
    const history = useNavigate();

    const nextStep = (step, validate = true) => {
        if (!validate) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            setCurrentTab(step);
        }
        if (step === 2) {
            let flag = false;
            const error = { username: "", apiError: "" };
            if (!username || username.replaceAll(/\s/g, '').length < 3 || !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(username)) {
                error.username = 'Please provide a valid email';
                flag = true
            }
            setErrors(error)
            if (!flag) {
                setLoading(true)
                postEmailOTP("/otp/email", { username: username }).then((data) => {
                    if (data.message === "OTP sent successfully") {
                        setLoading(false)
                        showToast("success", "OTP Sent Successfully", "Please check your email inbox.")
                        setCurrentTab(2)
                    }
                    else {
                        setLoading(false)
                        showToast("error", "Request Failed", "There is a problem sending your OTP.")
                    }
                }).catch((e) => {
                    const error = { username: "", password: "", otp: "", apiError: e }
                    setErrors(error);
                    // resetForm();
                    setLoading(false)
                })
            }
        }
        if (step === 3) {
            let flag = false;
            const error = { username: "", otp: "", apiError: "" };
            if (!otp) {
                error.otp = 'Please provide a valid OTP';
                flag = true
            }
            setErrors(error)
            if (!flag) {
                setLoading(true)
                postVerifyEmailOTP("/otp/verify", { otp: Number(otp), username: username }).then((data) => {
                    if (data.success) {
                        setLoading(false)
                        showToast("success", "OTP Verified", "OTP verified successfully.")
                        setCurrentTab(3)
                    }
                    else {
                        setLoading(false)
                        showToast("error", "Request Failed", "There is a problem verifying your OTP.")
                    }
                }).catch((e) => {
                    const error = { username: "", password: "", otp: "", apiError: e }
                    setErrors(error);
                    // resetForm();
                    setLoading(false)
                })
            }
        }
        if (step === 4) {
            let flag = false;
            const error = { username: "", otp: "", password: "", passwordRepeat: "", apiError: "" };
            if (!password || !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/.test(password)) {
                error.password = 'Password must contain at least 8 character, one upper and lowercase letter, one digit and one special character';
                flag = true
            }
            if (password !== passwordRepeat) {
                error.passwordRepeat = 'Password do not match';
                flag = true
            }
            setErrors(error)
            if (!flag) {
                setLoading(true)
                resetPassword("/auth/reset-password", { otp: Number(otp), password: password, username: username }).then((data) => {
                    if (data.success) {
                        setLoading(false)
                        showToast("success", "Password Changed", "Password has been changed successfully.")
                        history("/")
                    }
                    else {
                        setLoading(false)
                        showToast("error", "Request Failed", "There is a problem changing your password.")
                    }
                }).catch((e) => {
                    const error = { username: "", password: "", otp: "", apiError: e }
                    setErrors(error);
                    // resetForm();
                    setLoading(false)
                })
            }
        }
    }

    const resetForm = () => {
        setUsername("");
    }
    const resetErrors = () => {
        const error = { username: "", password: "", apiError: "" }
        setErrors(error);
    }

    return (
        <div>
            <Container fluid className="p-0">
                <Row className="g-0">
                    <Col lg={6} className='my-auto'>
                        <div style={{ width: "100%", maxWidth: "680px", height: "100vh" }} className='mx-auto'>
                            {errors.apiError ? <Alert color="danger">{errors.apiError}</Alert> : null}
                            <div className="p-2 my-auto">
                                <form className="form-horizontal">
                                    {
                                        currentTab === 1 ?
                                            <>
                                                <div className='text-center'>
                                                    <Link to="/" className="">
                                                        <img src={logo} alt="" height="60" className="auth-logo mx-auto" />
                                                    </Link>
                                                    <h3 className="fs-34 fw-500 mt-2 text-dark">Forgot Password</h3>
                                                    <p className="text-muted-200 p-0 mb-4 m-0 w-50 mx-auto">Enter your email and we'll send you 6-digit code to reset your password</p>
                                                </div>
                                                <div className="auth-form-group-custom mb-2 position-relative">
                                                    <Input name="username" value={username} onChange={(e) => { setUsername(e.target.value) }} type="text" className={`ps-2 form-control text-gray-100 ${errors.userName ? "is-invalid" : ""}`} id="username" placeholder="Email Address" style={{ border: '1px solid #f1f1f1', WebkitTextFillColor: '#939393', WebkitBoxShadow: '0 0 0px 1000px #f1f1f1 inset', transition: 'background-color 5000s ease-in-out 0s', }} />
                                                    {/* <i className="ri-search-line fs-16 position-absolute text-muted top-50 translate-middle-y ms-2 bg-white rounded"></i> */}
                                                </div>
                                                {errors.username ? <div className="invalid-feedback mb-3 mt-0">{errors.username}</div> : null}
                                                <div className="mt-4 text-center">
                                                    <Button disabled={loading} type='button' onClick={() => { nextStep(2) }} className="btn-lg w-100 linear-gradient-btn">{loading ? "Please Wait" : "Continue"}</Button>
                                                </div>
                                            </>
                                            :
                                            currentTab === 2 ?
                                                <>
                                                    <div className='text-center'>
                                                        <Link to="/" className="">
                                                            <img src={logo} alt="" height="60" className="auth-logo mx-auto" />
                                                        </Link>
                                                        <h3 className="fs-34 fw-500 mt-2 text-dark">Verify 6-digit code</h3>
                                                        <p className="text-gray-200 p-0 mb-0 m-0">{`Enter the verification code that we sent to`} <span className='text-primary'>{username}</span></p>
                                                        <p className="text-gray-200 p-0 mb-4 m-0">{`Not your email?`} <span className='text-primary' onClick={() => { setCurrentTab(1) }} style={{ cursor: "pointer" }}>Change</span></p>
                                                    </div>
                                                    <div className="d-flex justify-content-center gap-2 mb-4">
                                                        <OtpInput
                                                            value={otp}
                                                            onChange={setOtp}
                                                            numInputs={6}
                                                            shouldAutoFocus={true}
                                                            renderSeparator={<span> </span>}
                                                            renderInput={(props) => <input {...props} />}
                                                            inputStyle={{ width: "60px", height: "60px", borderRadius: "7px", border: "none", backgroundColor: "#f1f1f1", fontSize: "20px" }}
                                                            containerStyle={"otp-input"}

                                                        />
                                                    </div>
                                                    <div className='text-center'>
                                                        {errors.otp ? <div className="invalid-feedback mb-3 mt-0">{errors.otp}</div> : null}
                                                    </div>

                                                    <Button disabled={loading} color="primary" onClick={() => { nextStep(3) }} className="w-100" style={{ background: "var(--wr-gradient-brand)" }}>Verify</Button>
                                                </>
                                                :
                                                <>
                                                    <div className='text-center'>
                                                        <Link to="/" className="">
                                                            <img src={logo} alt="" height="60" className="auth-logo mx-auto" />
                                                        </Link>
                                                        <h3 className="fs-34 fw-500 mt-2 text-dark">Change Password</h3>
                                                        <p className="text-muted-200 p-0 mb-4 m-0 w-50 mx-auto">Enter a new password below to change your password</p>
                                                    </div>
                                                    <div className="auth-form-group-custom mb-2 position-relative" id='passwordInfo'>
                                                        <Input name="password" value={password} autoComplete='off' onChange={(e) => setPassword(e.target.value.slice(0, 50))} type={showPassword ? "text" : "password"} className={`form-control`} id="userpassword" placeholder="Password" style={{ border: '1px solid #f1f1f1', WebkitTextFillColor: '#939393', WebkitBoxShadow: '0 0 0px 1000px #f1f1f1 inset', transition: 'background-color 5000s ease-in-out 0s', }} />
                                                        <i
                                                            className={`ri-${showPassword ? "eye-off" : "eye"}-line show-hide-password-icon`}
                                                            onClick={() => setShowPassword((prev) => !prev)}
                                                        ></i>
                                                        <UncontrolledTooltip placement="top" style={{ minWidth: "250px" }} popperClassName="text-left" innerClassName="text-left" target={`passwordInfo`}>
                                                            {
                                                                <ul className='m-0 pl-3 text-left' >
                                                                    <li className='mb-1 mt-0 text-left'>Password must contain at least 8 characters</li>
                                                                    <li className='mb-1 mt-0 text-left'>One uppercase letter</li>
                                                                    <li className='mb-1 mt-0 text-left'>One lowercase letter</li>
                                                                    <li className='mb-1 mt-0 text-left'>One digit</li>
                                                                    <li className='mb-1 mt-0 text-left'>One special character</li>
                                                                </ul>

                                                            }
                                                        </UncontrolledTooltip>
                                                    </div>
                                                    {errors.password ? <div className="invalid-feedback mb-2">{errors.password}</div> : null}
                                                    <div className="auth-form-group-custom mb-2 position-relative">
                                                        <Input name="password" value={passwordRepeat} onChange={(e) => setPasswordRepeat(e.target.value.slice(0, 50))} type={showPasswordRepeat ? "text" : "password"} className={`form-control`} id="userpassword" placeholder="Re-type Password" style={{ border: '1px solid #f1f1f1', WebkitTextFillColor: '#939393', WebkitBoxShadow: '0 0 0px 1000px #f1f1f1 inset', transition: 'background-color 5000s ease-in-out 0s', }} />
                                                        <i
                                                            className={`ri-${showPasswordRepeat ? "eye-off" : "eye"}-line show-hide-password-icon`}
                                                            onClick={() => setShowPasswordRepeat((prev) => !prev)}
                                                        ></i>
                                                    </div>
                                                    {errors.passwordRepeat ? <div className="invalid-feedback mb-2">{errors.passwordRepeat}</div> : null}

                                                    <Button disabled={loading} color="primary" onClick={() => { nextStep(4) }} className="w-100 mt-3" style={{ background: "var(--wr-gradient-brand)" }}>Change Password</Button>
                                                </>
                                    }
                                </form>
                            </div>
                        </div>
                    </Col>
                    <Col md={6} className='text-right'>
                        <img src={authBanner} alt="" className='auth-banner-image' />
                    </Col>
                </Row>
            </Container>
        </div>

    );

}


export default ForgotPassword